import { Col, Row } from "antd";
import "antd/dist/antd.css";
import unescape from "lodash/unescape";
import PropTypes from "prop-types";
import React, { createRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumb from "../../../../CommonComponents/Breadcrumb/Breadcrumb.js";
import { PagesHeading } from "../../../../CommonComponents/commonStyles.js";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import TimelineDesktop from "../../../../CommonComponents/TimelineAssembly/TimelineDesktop.js";
import TimelineMobile from "../../../../CommonComponents/TimelineAssembly/TimelineMobile.js";
import "../../../../styles/theme.js";
import { initiateTracking, recordError } from "../../../../utils/commonUtil";
import GrantAgreement from "../HowItWorks/Components/GrantAgreement";
import InternationalGrant from "../HowItWorks/Components/InternationalGrant";
import { fetchHowItWorksData } from "./actions";
import "./HowItWorks.css";
import { howItWorksDerivedStates } from "./selectors.js";
import { GrantWrapper, HowItWorksBody, HowItWorksTitle, HowItWorksWrapper, LoaderWrapper } from "./styles.js";

class HowItWorks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "none",
      showMoreButtonDisplayButton: true,
      currentItemId: undefined,
      accordionStatus: undefined,
      screenWidth: window.innerWidth
    };

    this.desktopRefs = new Array(5).fill(null).map(() => createRef());
  }

  handleScrollToTOp = (id, expand, subTitle) => {
    try {
      if (!expand && this.desktopRefs[id - 1].current) {
        window.scrollTo(0, this.desktopRefs[id - 1].current.getOffsetTop);
      } else {
        initiateTracking(
          "showMore",
          "Grants - How it works",
          unescape(subTitle),
          "Show More"
        );
        if (id === 1) {
          setTimeout(this.ctaEventHandler);
        }
      }
    } catch (err) {
      recordError(err);
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getHowItWorksDetails({
      metaData: {
        method: "GET",
        url: `/grant-how-it-works`,
        page: "howItWorks",
        isExternal: true
      }
    });
    window.onresize = this.resizeHandler;
  }

  resizeHandler = e => {
    this.setState({
      screenWidth: e.currentTarget.innerWidth
    });
  };

  componentWillUnmount() {
    window.onresize = null;
  }

  ctaEventHandler = () => {
    const guideStar = document.getElementById("guidestarlink");
    const mailToDonor = document.getElementById("mailtodonorservice");
    const mailToCharities = document.getElementById(
      "mailtopremierserviceforcharities"
    );
    const mailToGrant = document.getElementById("mailtopremierserviceforgrant");

    const { howItWorksDetails } = this.props;
    let pageTitle;
    if (howItWorksDetails && howItWorksDetails.field_page_title) {
      pageTitle = howItWorksDetails.field_page_title.includes(":")
        ? howItWorksDetails.field_page_title.replace(":", " -")
        : howItWorksDetails.field_page_title;
    }

    if (guideStar) {
      guideStar.onclick = () => {
        let text = guideStar.innerText;
        initiateTracking("outBoundClick", pageTitle, "Outbound Link", text);
      };
    }

    if (mailToDonor) {
      mailToDonor.onclick = () => {
        let text = mailToDonor.innerText;
        initiateTracking("email", pageTitle, "Update name or address", text);
      };
    }

    if (mailToCharities) {
      mailToCharities.onclick = () => {
        let text = mailToCharities.innerText;
        let action = howItWorksDetails.field_nternational_grant_title.includes(
          "?"
        )
          ? howItWorksDetails.field_nternational_grant_title
              .replace("?", "")
              .trim()
          : howItWorksDetails.field_nternational_grant_title.trim();
        initiateTracking("email", pageTitle, action, text);
      };
    }

    if (mailToGrant) {
      mailToGrant.onclick = () => {
        let text = mailToGrant.innerText;
        let action = howItWorksDetails.field_grant_agreements_title.includes(
          "?"
        )
          ? howItWorksDetails.field_grant_agreements_title
              .replace("?", "")
              .trim()
          : howItWorksDetails.field_grant_agreements_title.trim();
        initiateTracking("email", pageTitle, action, text);
      };
    }
  };

  render() {
    const { howItWorksDetails } = this.props;
    const {
      segmentation,
      grantAgreementFlag
    } = this.props.additionalAccountDetails;
    const breadcrumbRoutes = () => {
      return [
        {
          routeName: "Home",
          path: "/"
        },
        {
          routeName: "Grants",
          path: "/grants"
        },
        {
          routeName: "How it Works",
          path: ""
        }
      ];
    };
    return (
      <div data-test="howItWorks">
        <HowItWorksWrapper>
          <Row className="main-max-width-container">
            <Breadcrumb breadcrumbRoutes={breadcrumbRoutes()} />
            {this.props.howItWorksDetails &&
            this.props.howItWorksDetails.field_page_title ? (
              <HowItWorksBody>
                <div>
                  <PagesHeading marginBottom='0.5rem'>{howItWorksDetails.field_page_title}</PagesHeading>
                </div>
                <HowItWorksTitle>
                  <Col span={24}>
                    <div>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: howItWorksDetails.field_page_description
                        }}
                      ></span>
                    </div>
                  </Col>
                </HowItWorksTitle>
                {this.state.screenWidth > 767 && (
                  <>
                    <TimelineDesktop
                      desktopRefs={this.desktopRefs}
                      howItWorksDetails={howItWorksDetails}
                      handleScrollToTOp={this.handleScrollToTOp}
                    />
                  </>
                )}
                {/* Mobile view */}
                {this.state.screenWidth <= 767 && (
                  <div className="howItWorksMobile">
                    <TimelineMobile
                      desktopRefs={this.desktopRefs}
                      howItWorksDetails={howItWorksDetails}
                      handleScrollToTOp={this.handleScrollToTOp}
                    />
                  </div>
                )}

                <Row style={GrantWrapper} type="flex" justify="space-between">
                  {segmentation &&
                  segmentation === "Premier" &&
                  howItWorksDetails &&
                  howItWorksDetails.field_off_international_granting &&
                  howItWorksDetails.field_off_international_granting ===
                    "Off" ? (
                    <InternationalGrant
                      ctaEventHandler={this.ctaEventHandler.bind(this)}
                      internationalGrantTitle={
                        howItWorksDetails.field_nternational_grant_title
                      }
                      internationalGrantDescription={
                        howItWorksDetails.field_international_grant_desc
                      }
                      pageTitle={howItWorksDetails.field_page_title}
                    />
                  ) : (
                    <div></div>
                  )}
                  {grantAgreementFlag &&
                  howItWorksDetails &&
                  howItWorksDetails.field_turn_off_grant_agreements &&
                  howItWorksDetails.field_turn_off_grant_agreements ===
                    "Off" ? (
                    <GrantAgreement
                      ctaEventHandler={this.ctaEventHandler.bind(this)}
                      grantAgreementTitle={
                        howItWorksDetails.field_grant_agreements_title
                      }
                      grantAgreementDescription={
                        howItWorksDetails.field_grant_agreements_desc
                      }
                      pageTitle={howItWorksDetails.field_page_title}
                    />
                  ) : (
                    <div></div>
                  )}
                </Row>
              </HowItWorksBody>
            ) : (
              <div>
                <Row>
                  <Col>
                    <LoaderWrapper>
                      <Preloader />
                    </LoaderWrapper>
                  </Col>
                </Row>
              </div>
            )}
          </Row>
        </HowItWorksWrapper>
      </div>
    );
  }
}

HowItWorks.propTypes = {
  additionalAccountDetails: PropTypes.object,
  getHowItWorksDetails: PropTypes.func,
  howItWorksDetails: PropTypes.shape({
    field_grant_agreements_desc: PropTypes.string,
    field_grant_agreements_title: PropTypes.string,
    field_international_grant_desc: PropTypes.string,
    field_nternational_grant_title: PropTypes.string,
    field_off_international_granting: PropTypes.string,
    field_page_description: PropTypes.string,
    field_page_title: PropTypes.string,
    field_step_2_status_1: PropTypes.string,
    field_step_2_status_1_tooltip: PropTypes.string,
    field_step_2_status_2: PropTypes.string,
    field_step_2_status_2_tooltip: PropTypes.string,
    field_step_2_status_title: PropTypes.string,
    field_step_3_status_1: PropTypes.string,
    field_step_3_status_1_tooltip: PropTypes.string,
    field_step_3_status_2: PropTypes.string,
    field_step_3_status_2_tooltip: PropTypes.string,
    field_step_3_status_title: PropTypes.string,
    field_step_4_status_1: PropTypes.string,
    field_step_4_status_1_tooltip: PropTypes.string,
    field_step_4_status_2: PropTypes.string,
    field_step_4_status_2_tooltip: PropTypes.string,
    field_step_4_status_title: PropTypes.string,
    field_turn_off_grant_agreements: PropTypes.string
  })
};

const mapStateToProps = state => ({
  ...howItWorksDerivedStates(state.toJS())
});
export const mapDispatchToProps = dispatch => ({
  getHowItWorksDetails: data => dispatch(fetchHowItWorksData(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HowItWorks)
);
